import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

export const StatusTemplateContext = createContext({ })

export const useStatusTemplateContext = () => {
  return useContext(StatusTemplateContext)
}

export const useSectionEditing = (sectionName) => {
  const { editing, section } = useStatusTemplateContext()
  return useMemo(() => {
    return editing && section === sectionName
  }, [editing, section, sectionName])
}

const useProviderValue = ({ statusTemplate, isFetching }) => {
  const [formState, setFormState] = useState({
    editing: false,
    section: null
  })

  const editSection = useCallback(({
    section
  }) => {
    setFormState((prevState) => ({
      ...prevState,
      editing: !prevState.editing,
      section: !prevState.editing ? section : null
    }))
  }, [setFormState])

  const cancelEdit = useCallback(() => {
    setFormState((prevState) => ({
      ...prevState,
      editing: false,
      section: null
    }))
  }, [setFormState])

  return useMemo(() => ({
    statusTemplate,
    editSection,
    cancelEdit,
    isFetching,
    ...formState
  }), [statusTemplate, editSection, cancelEdit, formState, isFetching])
}

export const StatusTemplateProvider = ({ statusTemplate, isFetching, children }) => {
  const value = useProviderValue({
    statusTemplate,
    isFetching
  })

  return (
    <StatusTemplateContext.Provider value={value}>
      {children}
    </StatusTemplateContext.Provider>
  )
}

StatusTemplateProvider.propTypes = {
  statusTemplate: PropTypes.object,
  children: PropTypes.node,
  isFetching: PropTypes.bool
}

StatusTemplateProvider.defaultProps = {
}
